import { render, staticRenderFns } from "./PPButtonOptions.vue?vue&type=template&id=15be1796&"
import script from "./PPButtonOptions.vue?vue&type=script&lang=js&"
export * from "./PPButtonOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports